export default __webpack_public_path__ + "static/media/2.6b31c430.jpg";